/**
 * Module-scoped flag that tracks whether the current browsing context was
 * entered via an access-token redirect (session link).
 *
 * Unlike sessionStorage, this flag is isolated per JavaScript execution
 * context — the parent window and an embedded iframe each get their own
 * copy. It survives React Router navigations but resets on page refresh.
 */
let fromAccessTokenRedirect = false;

export const setAccessTokenRedirectFlag = (): void => {
  fromAccessTokenRedirect = true;
};

export const isAccessTokenRedirect = (): boolean => fromAccessTokenRedirect;
